<template>
    <div class="pb-3 d-flex justify-content-between align-items-center performances-calendar-cinema-search-wrapper">
        <i class="mr-3 fas fa-search color-brand--secondary font-size-h4"></i>

        <input type="search"
               v-model="searchCinema"
               class="w-100 font-size-medium color-brand--secondary performances-calendar-cinema-search-input"
               placeholder="Zoek naar bioscoop of stad"
               @keyup="search">

        <i class="fas fa-times" v-show="searchCinema.length" @click="emptySearchInput"></i>
    </div>
</template>

<script>
    export default {
        props: {
            movieId: {
                type: Number,
                required: true,
            },
            searchString: {
                type: String,
                required: false,
            }
        },
        data() {
            return {
                eventName: 'movie_performances_calendar_filter',
                searchCinema: '',
                timer: null
            };
        },
        methods: {
            search() {
                clearTimeout(this.timer);
                let self = this;
                this.timer = setTimeout(function() {
                        if(self.searchCinema.length >= 3) {
                            MrMovie.pageFilter.removeFilters('city');
                            MrMovie.pageFilter.removeFilters('cinema');
                            MrMovie.pageFilter.removeFilters('search');
                            MrMovie.pageFilter.addFilters('search', [self.searchCinema]);
                            MrMovie.pageFilter.updateQueryParams();
                            MrMovie.pageFilter.filter();
                        } else if(typeof MrMovie.pageFilter.getFilters('search' !== 'undefined')) {
                            MrMovie.pageFilter.removeFilters('search');
                            MrMovie.pageFilter.updateQueryParams();
                            MrMovie.pageFilter.filter();
                        }
                    },
                    400   // Guestimate the best value you want, usually I use 300 - 400 ms
                )

            },
            emptySearchInput() {
                this.searchCinema = '';
                if(typeof MrMovie.pageFilter.getFilters('search' !== 'undefined')) {
                    MrMovie.pageFilter.removeFilters('search');
                    MrMovie.pageFilter.updateQueryParams();
                    MrMovie.pageFilter.filter();
                }

            },
        },
        mounted() {
            if(this.searchString.length) {
                this.searchCinema = this.searchString;
                MrMovie.pageFilter.addFilters('search', [this.searchCinema]);
            }

            VueEvents.$on('location-filter:manual-triggered', args => {
                this.searchCinema = '';
                MrMovie.pageFilter.removeFilters('search');
                MrMovie.pageFilter.updateQueryParams();
            });

        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/single/MoviePerformancesCalendarSearch.vue